export { default as Animation } from './animations/animation';
export { default as AnimationFactory } from './animations/animation-factory';


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/animations.js
// module id = ../../../../@progress/kendo-drawing/dist/es/animations.js
// module chunks = vendor